{
	"appId": {
		"development": "189752094378413",
		"jade": "316488855105630",
		"teal": "539101939464330",
		"noir": "1726577350918927",
		"plum": "120864301881896",
		"vert": "294901034268168",
		"cyan": "323251017699353",
		"opal": "2325896240968291",
		"orion": "1273437940056888",
		"staging": "206130729737423",
		"production": "48409868550"
	},
	"namespace": {
		"development": "change_org_dev",
		"jade": "change_org_jade",
		"teal": "change_org_teal",
		"noir": "change_org_noir",
		"plum": "change_org_plum",
		"vert": "change_org_vert",
		"cyan": "change_org_cyan",
		"opal": "change_org_opal",
		"orion": "change_org_orion",
		"staging": "change_org_staging",
		"production": "change-org"
	},
	"vanity": {
		"AR": "Change.orgArgentina",
		"AU": "Change.orgAustralia",
		"BO": "Change.orgLatino",
		"BR": "Change.orgBrasil",
		"BY": "changeorgrus",
		"CA": "Change.orgCanada",
		"CL": "Change.orgLatino",
		"CO": "Change.orgLatino",
		"CR": "Change.orgLatino",
		"CU": "Change.orgLatino",
		"DE": "Change.orgDeutschland",
		"DO": "Change.orgLatino",
		"EC": "Change.orgLatino",
		"ES": "changeorgespana",
		"FR": "Change.orgFrance",
		"GB": "Change.orgUK",
		"GG": "Change.orgUK",
		"GI": "Change.orgUK",
		"GT": "Change.orgLatino",
		"HN": "Change.orgLatino",
		"ID": "Change.orgIndonesia",
		"IM": "Change.orgUK",
		"IN": {
			"vanity": "Change.orgIndia",
			"localesOverrides": {
				"hi-IN": "ChangeHindi"
			}
		},
		"IT": "Change.orgItalia",
		"JE": "Change.orgUK",
		"JP": "Change.orgJapan",
		"MX": "Change.orgMexico",
		"NI": "Change.orgLatino",
		"PA": "Change.orgLatino",
		"PE": "Change.orgLatino",
		"PH": "ChangePilipinas",
		"PR": "Change.orgLatino",
		"PY": "Change.orgLatino",
		"RU": "Change.orgRussia",
		"SV": "Change.orgLatino",
		"TH": "changeorgthailand",
		"TR": "Change.orgTurkey",
		"UA": "changeorgrus",
		"US": "change.org",
		"UY": "Change.orgLatino",
		"VE": "Change.orgLatino",
		"ZA": "Change.orgSouthAfrica"
	},
	"defaultVanity": "change.org",
	"locales": {
		"de-DE": "de_DE",
		"en-AU": "en_GB",
		"en-CA": "en_GB",
		"en-GB": "en_GB",
		"en-IN": "en_GB",
		"en-US": "en_US",
		"es-ES": "es_ES",
		"es-419": "es_LA",
		"es-AR": "es_LA",
		"fr-FR": "fr_FR",
		"hi-IN": "hi_IN",
		"id-ID": "id_ID",
		"it-IT": "it_IT",
		"ja-JP": "ja_JP",
		"ko-KR": "ko_KR",
		"pt-BR": "pt_BR",
		"ru-RU": "ru_RU",
		"th-TH": "th_TH",
		"tr-TR": "tr_TR"
	},
	"localesReverse": {
		"de_DE": "de-DE",
		"en_GB": "en-GB",
		"en_US": "en-US",
		"es_ES": "es-ES",
		"es_LA": "es-419",
		"fr_FR": "fr-FR",
		"hi_IN": "hi-IN",
		"id_ID": "id-ID",
		"it_IT": "it-IT",
		"ja_JP": "ja-JP",
		"ko_KR": "ko-KR",
		"pt_BR": "pt-BR",
		"ru_RU": "ru-RU",
		"th_TH": "th-TH",
		"tr_TR": "tr-TR"
	}
}
